import { createTheme } from '@mui/material'

const primaryDarkBlue = '#002677'
const inputBg = '#eff2f8'
const inputFocusBg = 'rgba(65, 107, 246, 0.15)'

export const theme = createTheme({
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '60px',
          backgroundColor: inputBg,
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: inputBg,
          },
          '&.Mui-focused': {
            backgroundColor: inputFocusBg,
          },
          '&.Mui-error': {
            borderColor: '#f44336',
          },
          '&:before': {
            borderBottom: 'none',
          },
          '&:hover:not(.Mui-focused):before': {
            borderBottom: 'none',
          },
          '&:after': {
            transition: 'none',
            borderBottom: '2px solid #416bf6',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: primaryDarkBlue,
          fontSize: 18,
          fontWeight: 300,
          fontFamily: 'URW Geometric Ext', // Default label color
          '&.Mui-focused': {
            color: primaryDarkBlue, // Color when the input is focused
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: primaryDarkBlue,
          fontWeight: 600,
          fontFamily: 'URW Geometric Ext',
          fontSize: '18px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        filled: {
          backgroundColor: 'transparent',
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: primaryDarkBlue, // Text color of the menu items
          fontSize: '18px',
          fontFamily: 'URW Geometric Ext',
          fontWeight: 600,
          backgroundColor: '#fff',
          '&.Mui-selected': {
            backgroundColor: inputFocusBg, // Selected item background color
          },
          '&.Mui-selected:hover': {
            backgroundColor: inputFocusBg, // Hover color for selected item
          },
          '&:hover': {
            backgroundColor: inputBg, // Hover color for non-selected items
          },
          '&.Mui-focusVisible': {
            backgroundColor: inputBg,
          },
        },
      },
    },

    MuiPopover: {
      styleOverrides: {
        paper: {
          maxHeight: '208px !important', // Set max height for the select menu
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        option: {
          color: primaryDarkBlue,
          fontSize: '18px',
          fontFamily: 'URW Geometric Ext',
          fontWeight: 600,
          backgroundColor: '#fff',
          '&[aria-selected="true"]': {
            backgroundColor: inputBg,
          },
          '&[aria-selected="true"]:hover': {
            backgroundColor: inputBg,
          },
          '&:hover': {
            backgroundColor: inputBg,
          },
          '&.Mui-focusVisible': {
            backgroundColor: inputBg,
          },
        },
        listbox: {
          maxHeight: '284px',
          '& .MuiAutocomplete-option:hover': {
            backgroundColor: inputBg,
          },
          '& .MuiAutocomplete-option.Mui-focusVisible': {
            backgroundColor: inputBg,
          },
          '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: inputFocusBg,
          },
          '& .MuiAutocomplete-option[aria-selected="true"]:hover': {
            backgroundColor: inputBg,
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: primaryDarkBlue, // Default text color
          fontSize: '18px',
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          '&.Mui-selected': {
            backgroundColor: '#416BF6', // Background color for selected page
            color: '#FFFFFF', // Optional: Text color for selected page
          },
        },
      },
    },
  },
})
